import { render, staticRenderFns } from "./DiskHeader.vue?vue&type=template&id=56d43a88&scoped=true"
import script from "./DiskHeader.vue?vue&type=script&lang=js"
export * from "./DiskHeader.vue?vue&type=script&lang=js"
import style0 from "./DiskHeader.vue?vue&type=style&index=0&id=56d43a88&lang=scss&scoped=true"
import style1 from "./DiskHeader.vue?vue&type=style&index=1&id=56d43a88&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d43a88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/aimer/TM/KB/Knowledge-base/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d43a88')) {
      api.createRecord('56d43a88', component.options)
    } else {
      api.reload('56d43a88', component.options)
    }
    module.hot.accept("./DiskHeader.vue?vue&type=template&id=56d43a88&scoped=true", function () {
      api.rerender('56d43a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/cloud-disk/src/views/DiskHeader.vue"
export default component.exports